import { axiosInstance } from "../../axios-Instance";
import { getLoginToken } from "../../storage";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { queryKeys } from "../../react-query/constants";

async function getCourses() {
  const data = await axiosInstance({
    url: "/courses",
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${getLoginToken()}`,
    },
  });

  return data?.data?.data;
}

const createCourses = async (formData: any) => {
  const data = await axiosInstance({
    url: "/courses",
    method: "POST",
    data: formData,
    headers: {
      "Content-Type": "multipart/form-data",
      Authorization: `Bearer ${getLoginToken()}`,
    },
  });
  return data?.data?.data;
};

const uploadVideo = async (formData: any) => {
  const data = await axiosInstance({
    url: "/courses/videoUpload",
    method: "POST",
    data: formData,
    headers: {
      "Content-Type": "multipart/form-data",
      Authorization: `Bearer ${getLoginToken()}`,
    },
  });
  return data;
};

const updateCourses = async (formData: any) => {
  const data = await axiosInstance({
    url: `/courses/${formData["_id"]}`,
    method: "PUT",
    data: formData,
    headers: {
      "Content-Type": "multipart/form-data",
      Authorization: `Bearer ${getLoginToken()}`,
    },
  });
  return data;
};

const updateSection = async (formData: any) => {
  const data = await axiosInstance({
    url: `/courses/${formData["_id"]}/${formData["section._id"]}/${formData["video._id"]}`,
    method: "PUT",
    data: formData,
    headers: {
      "Content-Type": "multipart/form-data",
      Authorization: `Bearer ${getLoginToken()}`,
    },
  });
  return data;
};

const deleteSection = async (formData: any) => {
  const data = await axiosInstance({
    url: `/courses/${formData["_id"]}/${formData["section._id"]}/${formData["video._id"]}`,
    method: "DELETE",
    data: formData,
    headers: {
      "Content-Type": "multipart/form-data",
      Authorization: `Bearer ${getLoginToken()}`,
    },
  });
  return data;
};

const deleteCourses = async (formData: any) => {
  const data = await axiosInstance({
    url: `/courses/${formData}`,
    method: "DELETE",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${getLoginToken()}`,
    },
  });
  return data;
};

export function useCourses() {
  const fallback: any = [];
  const { data = fallback } = useQuery({
    queryKey: [queryKeys.courses],
    queryFn: () => getCourses(),
  });
  return data;
}

export function useCreateCourses() {
  const queryClient = useQueryClient();
  const { mutate, isSuccess, reset, isError, error, data } = useMutation({
    mutationFn: (formData) => createCourses(formData),
    onSuccess: (data) => {
      queryClient.invalidateQueries([queryKeys.courses]);
    },
  });
  return { mutate, isSuccess, reset, isError, error, data };
}

export function useUploadVideo() {
  const queryClient = useQueryClient();
  const { mutate, isSuccess, reset, isError, error } = useMutation({
    mutationFn: (formData) => uploadVideo(formData),
    onSuccess: (data) => {
      queryClient.invalidateQueries([queryKeys.courses]);
    },
  });
  return { mutate, isSuccess, reset, isError, error };
}

export function useUpdateVideoSection() {
  const queryClient = useQueryClient();
  const { mutate, isSuccess, reset, isError, error } = useMutation({
    mutationFn: (formData) => updateSection(formData),
    onSuccess: (data) => {
      queryClient.invalidateQueries([queryKeys.courses]);
    },
  });
  return { mutate, isSuccess, reset, isError, error };
}
export function useDeleteVideoSection() {
  const queryClient = useQueryClient();
  const { mutate, isSuccess, reset, isError, error } = useMutation({
    mutationFn: (formData) => deleteSection(formData),
    onSuccess: (data) => {
      queryClient.invalidateQueries([queryKeys.courses]);
    },
  });
  return { mutate, isSuccess, reset, isError, error };
}

export function useUpdateCourses() {
  const queryClient = useQueryClient();
  const { mutate, isSuccess, reset, isError, error } = useMutation({
    mutationFn: (formData) => updateCourses(formData),
    onSuccess: (data) => {
      queryClient.invalidateQueries([queryKeys.courses]);
    },
  });
  return { mutate, isSuccess, reset, isError, error };
}

export function useDeleteCourses() {
  const queryClient = useQueryClient();
  const { mutate, isSuccess, reset, isError, error } = useMutation({
    mutationFn: (formData) => deleteCourses(formData),
    onSuccess: (data) => {
      queryClient.invalidateQueries([queryKeys.courses]);
    },
  });
  return { mutate, isSuccess, reset, isError, error };
}
